import { render, staticRenderFns } from "./activityGifts.vue?vue&type=template&id=e05931b8"
import script from "./activityGifts.vue?vue&type=script&lang=js"
export * from "./activityGifts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports